import { render, staticRenderFns } from "./AppHeaderSpeedDial.vue?vue&type=template&id=05b23713"
import script from "./AppHeaderSpeedDial.vue?vue&type=script&lang=js"
export * from "./AppHeaderSpeedDial.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderSpeedDial.vue?vue&type=style&index=0&id=05b23713&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports